import Vue from 'vue'
import Swiper from 'swiper'
import { Pagination } from 'swiper/modules';

import 'swiper/css'
import 'swiper/css/pagination'

export default Vue.component(
  'carousel',
  {
    mounted () {
      const swiperEl = document.getElementById('canz-swiper')
      if (!swiperEl) { return }

      new Swiper(swiperEl, {
        speed: 500,
        // configure Swiper to use modules
        modules: [Pagination],

        // If we need pagination
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        }
      })
    }
  }
)
